import { Box, FormGroup } from "@mui/material";
import CustomSelect from "../../../common/components/CustomSelect";
import { ProvisionType, SpotMarket } from "../PricingRequestStepper.slice";
import { PricingRequestData } from "../pricingRequestStepper.module";
import { useMemo } from "react";
import { Tender } from "../../tender_page/tender.module";

interface UsSpecificsSelectorsProps {
    values: PricingRequestData;
    setFieldValue: (fieldName: string, value: any) => void;
    spotMarketsList: SpotMarket[];
    provisionTypesList: ProvisionType[];
	tender?: Tender;
}

function UsSpecificsSelectors(props: UsSpecificsSelectorsProps) {
    const {
		values,
		setFieldValue,
        spotMarketsList,
        provisionTypesList,
		tender
	} = props;

	const show = useMemo(() => {
		if (tender) {
			return tender.country_iso2_code === "US";
		}
		return false;
	}, [tender]);

    return (
        <>
            <Box
				flexGrow={1}
				display={"flex"}
				alignItems={"center"}
			>
				<FormGroup>
					<CustomSelect
						data-testid="provision_type"
						name="provisionType"
						label="Provision type"
						value={values.provisionType ?? ""}
						onChange={(event) => setFieldValue("provisionType", event.target.value)}
						sx={{
							width: "500px",
							background: "#fff",
							borderRadius: "0px",
							...(!show  && {
								display: "None",
							})
						}}
						items={provisionTypesList?.map((provisionType: ProvisionType) => {
							return {
								key: provisionType.id,
        						value: provisionType.name,
								label: provisionType.name,
							};
						})}
					></CustomSelect>
				</FormGroup>
			</Box>
			<Box
				flexGrow={1}
				display={"flex"}
				alignItems={"center"}
			>
				<FormGroup>
					<CustomSelect
						data-testid="spot_market"
						name="spotMarket"
						label="Spot market"
						value={values.spotMarket ?? ""}
						onChange={(event) => setFieldValue("spotMarket", event.target.value)}
						sx={{
							width: "500px",
							background: "#fff",
							borderRadius: "0px",
							...(!show  && {
								display: "None",
							})
						}}
						items={spotMarketsList?.map((spotMarket: SpotMarket) => {
							return {
								key: spotMarket.id,
    							value: spotMarket.name,
								label: spotMarket.name,
							};
						})}
					></CustomSelect>
				</FormGroup>
			</Box>
        </>				
    );
}

export default UsSpecificsSelectors;